import { useForgotPasswordMutation } from "../redux/services/authApi";
import { toast } from "sonner";
import { useEmailInput } from "../hooks/useEmailInput";
import { useNavigate } from "react-router-dom";
import { FLEETRIFYROUTEPATH } from "../routes/routesPath";
import { getApiErrorMessage } from "../utils/apiError";

export const useForgotPasswordController = () => {
  const { email, setEmail, isEmailValid, showEmailError } = useEmailInput();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const payload = { email };
      await forgotPassword(payload).unwrap();

      // success toast
      toast.success("OTP has been sent to your email");

      navigate(FLEETRIFYROUTEPATH.VERIFY_EMAIL, {
        state: { email, mode: "reset" },
      });
    } catch (err: any) {
      console.error("Forgot password error:", err);
      // Stay on this page (e.g. the email isn't registered) — no OTP screen.
      toast.error(
        getApiErrorMessage(err, "Oops! Failed to send reset email. Try again.")
      );
    }
  };

  return {
    email,
    isLoading,
    isEmailValid,
    showEmailError,
    setEmail,
    handleSubmit,
  };
};



